import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { useForm } from "react-hook-form";
import provisional from "../../Assets/images/provisionalLandingImageAflac.jpg";
import divider from "../../Assets/images/lpDividerLine.png";
import { useTranslation } from "react-i18next";
import * as httpClient from "../../../util/httpClient";
import PSSBannerMessage from "../PSSBannerMessage/PSSBannerMessage";

const Aflac = (props: any) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );
    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );
    const partnerID: number = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : 0
    );

    useEffect(() => {
        setTimeout(() => {
            let language =
                !!partnerLanguageOptions && partnerLanguageOptions.length > 1
                    ? document.cookie.split(";").filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language").length > 0
                        ? !!document.cookie
                              .split(";")
                              .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                              .split("=")[1]
                            ? document.cookie
                                  .split(";")
                                  .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                                  .split("=")[1]
                            : "en"
                        : "en"
                    : "en";
            i18nLang.changeLanguage(language);
        });
    }, []);
    const { register, errors, handleSubmit, reset, trigger, setValue } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
        defaultValues: {
            accessCode: "",
            zipCode: "",
        },
    });
    const [showAccessCodeField, setShowAccessCodeField] = useState(false);
    const [state, setState] = useState({
        accessCode: "",
        zipCode: "",
        showErrorMessage: false,
        showAccessCodeField: true,
        isLoading: false,
        errorMsg: "",
    });
    const handleInputChange = (event: any) => {
        const target = event.target;
        const value = target.value === "checkbox" ? target.checked : target.value;
        const name = target.name;
        if (name === "") {
            setState({
                ...state,
                [name]: value,
                showErrorMessage: false,
            });
        } else {
            setState({
                ...state,
                [name]: value,
            });
        }
    };

    const onSubmit = (data: any) => {
        setState({ ...state, isLoading: true, showErrorMessage: true });
        const requestBody = {
            provisionalID: data.accessCode,
            SecondLevelAuth: data.zipCode,
            partnerID: partnerID,
        };
        httpClient
            .sendRequest("POST", `api/PssLandingPage/GetPssLandingPage7?enrollFileRequired=true`, requestBody)
            .then((data) => {
                if (data.provisionalResponseLanding.length === 0) {
                    setShowAccessCodeField(true);
                } else if (data.provisionalResponseLanding.length != 0) {
                    props.history.push({
                        pathname:
                            "/Register?Type=" +
                            data.provisionalResponseLanding[0].contractStatus +
                            "&VALUE=" +
                            data.provisionalResponseLanding[0].provisionalID +
                            "&GNDNRLL=PSS",
                    });
                    window.location.reload();
                }
            })
            .catch(function (error) {
                reset();
                trigger();
                setState({ ...state, showErrorMessage: true, errorMsg: "Something went wrong. Please try again.", isLoading: false, accessCode: "", zipCode: "" });
            });
    };
    console.log(showAccessCodeField);
    return (
        <React.Fragment>
            {showAccessCodeField == true ? <PSSBannerMessage layout={"aflacpsslanding"} showAccessCodeField={showAccessCodeField} setShowAccessCodeField={setShowAccessCodeField} /> : <div className="retailer_text"></div>}
            <main is="x3d" id="l-page-content main-content">
                <div className="row l-page-container">
                    <div
                        style={{
                            backgroundImage: `url(${provisional})`,
                        }}
                        id="aflac-main-left-bg"
                    ></div>
                    <div className="aflac-right-content">
                        <h1>Access Your Aflac Fraud Protection Today!</h1>
                        <div className="receipt-code-copy pss2-receipt-code-copy pss7-mobile-recepit-code-copy">
                            For verification purposes, please provide the information requested below.
                            <br />
                            <br />
                            If you need assistance, contact a Resolution Specialist at{" "}
                            <a className="pss7-recepit-code-number" href="tel:866-826-8851">
                                866-826-8851
                            </a>
                            .
                        </div>
                        <form id="pss7-form-member-login" onSubmit={handleSubmit(onSubmit)}>
                            <div className="input-content pss2-input-content">
                                <div className="form-row pss-forms">
                                    <div className="form-label">
                                        <label className="access-code-label pss2-access-code-label" htmlFor="accessCode">
                                            Access Code
                                        </label>
                                    </div>
                                    <div className="form-input">
                                        <input
                                            aria-required="true"
                                            className="access-code-input-pin"
                                            type="text"
                                            id="accessCode"
                                            name="accessCode"
                                            onChange={handleInputChange}
                                            ref={register({
                                                required: true,
                                                maxLength: 100,
                                            })}
                                        />
                                    </div>
                                    {errors.accessCode && errors.accessCode.type === "required" && (
                                        <div className="form-row">
                                            <div role="alert" className="col-xs-12 col-no-gutter">
                                                <span className="error-msg">Access Code is required</span>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="form-row pss-forms">
                                    <div className="form-label">
                                        <label className="access-code-label pss2-access-code-label" htmlFor="zipCode">
                                            First 5 digits of Zip Code
                                        </label>
                                    </div>
                                    <div className="form-input">
                                        <input
                                            aria-required="true"
                                            className="access-code-input-pin"
                                            type="text"
                                            id="zipCode"
                                            name="zipCode"
                                            onChange={handleInputChange}
                                            ref={register({
                                                required: true,
                                                maxLength: 100,
                                            })}
                                        />
                                    </div>
                                    {errors.zipCode && errors.zipCode.type === "required" && (
                                        <div className="form-row">
                                            <div role="alert" className="col-xs-12 col-no-gutter">
                                                <span className="error-msg">First 5 digits of Zip Code is required</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="pss7-getstarted-rightcontent">
                                <button onClick={() => handleSubmit(onSubmit)} value="Get Started" className="aflac-submit-button">Get Started</button>
                                <a href="/app/Login" className="login-link">
                                    Click here to Log In
                                </a>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
            <div className="divider-img">
                <img src={divider} alt="" />
            </div>
        </React.Fragment>
    );
};
export default Aflac;
